<template>
  <span style="cursor: pointer;">
    <Logo />
  </span>
</template>

<script>
  import Logo from '@/components/Logo';
  export default {
    components: { Logo },
    computed: {
      partnerCode() { return this.$store.getters.settings.partnerCode; },
    },
  };
</script>
